import { ResponsiveTypography, ResponsiveTypographyVariant } from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../common/contexts';
import { BookingCardList } from '../BookingCardList';
import { IBookingPageTabProps } from './BookingsPage.interfaces';
import { BookingPageTabContainer } from './BookingsPage.styles';

const BookingsPageTab: React.FunctionComponent<IBookingPageTabProps> = props => {
  const { bookings, variant } = props;

  return (
    <BookingPageTabContainer>
      <BookingCardList bookings={bookings} variant={variant} />
      <BookingsPageFooter />
    </BookingPageTabContainer>
  );
};

const BookingsPageFooter: React.FunctionComponent = () => {
  const { translations } = React.useContext(TranslationsContext);

  return (
    <div>
      <ResponsiveTypography variant={ResponsiveTypographyVariant.micro} allowDangerousRender={true}>
        {i18n('account.bookings.awaitingPaymentBookings', [], translations)}
      </ResponsiveTypography>
      <br />
      <ResponsiveTypography variant={ResponsiveTypographyVariant.bodyBold}>
        {i18n('need.help', [], translations)}
      </ResponsiveTypography>
      <ResponsiveTypography variant={ResponsiveTypographyVariant.body} allowDangerousRender={true}>
        {i18n('visit.faq', [], translations)}
      </ResponsiveTypography>
    </div>
  );
};

export { BookingsPageTab };
